<script>
  // Round profile picture with the placeholder used across the CMS when the user has
  // no icon. Given `onclick`, it renders as a real button (keyboard reachable, and
  // `title` doubles as its accessible label).
  import Icon from './ui/icon.svelte'

  const SIZES = {
    sm: { box: 'h-8 w-8', icon: 'sm' },
    md: { box: 'h-10 w-10', icon: 'md' },
    lg: { box: 'h-14 w-14', icon: 'lg' }
  }

  let { url = null, name = '', size = 'md', title, onclick, class: className = '' } = $props()

  let failed = $state(false)
  $effect(() => {
    url
    failed = false
  })

  const dims = $derived(SIZES[size] ?? SIZES.md)
</script>

{#snippet visual()}
  {#if url && !failed}
    <img src={url} alt={name || 'Profile picture'} class="{dims.box} rounded-full object-cover block" onerror={() => (failed = true)} />
  {:else}
    <span class="{dims.box} rounded-full bg-base-300 flex items-center justify-center">
      <Icon name="users" size={dims.icon} class="text-base-content/40" />
    </span>
  {/if}
{/snippet}

{#if onclick}
  <button type="button" class="shrink-0 rounded-full p-0 border-0 bg-transparent cursor-pointer {className}" {title} aria-label={title || 'Profile picture'} {onclick}>
    {@render visual()}
  </button>
{:else}
  <span class="shrink-0 {className}" {title}>{@render visual()}</span>
{/if}
